import {
  IComposableDashboard,
  IComposableDashboardCollection,
  IPinnedDashboard,
  IPinnedDashboardCollection,
} from 'wisestep-api';

export const getDefaultDashboardValues = (): IComposableDashboard => ({
  name: '',
  charts: [],
  workspaceId: '',
  createdBy: '',
  accessLevel: '',
  sharedWithRecruiters: [],
  sharedWithTeams: [],
  sharedWithRoles: [],
  id: '',
  createdByName: '',
  createdOn: '',
  modifiedBy: '',
  modifiedOn: '',
  modifiedByName: '',
  description: '',
});

export const defaultPinnedDashboard: IPinnedDashboard = {
  id: '',
  dashboard: getDefaultDashboardValues(),
  users: [],
  teams: [],
  roles: [],
};

export const defaultDashboardCollection: IComposableDashboardCollection = {
  name: '',
  dashboardIds: [],
  createdBy: '',
  createdByName: '',
  workspaceId: '',
  accessLevel: '',
  sharedWithRecruiters: [],
  sharedWithTeams: [],
  sharedWithRoles: [],
  createdOn: '',
  modifiedBy: '',
  modifiedOn: '',
  modifiedByName: '',
  dashboards: [],
  assignToClients: false,
  assignToClientSpoc: false,
  assignToAccountManagerOU: false,
  assignToTeamsOU: false,
  description: '',
  assignToTeams: false,
  assignToBusinessUnit: false,
  assignToAccountManagers: false,
  assignToClientUnit: false,
  assignToClientContactUnit: false,
  assignToUsers: false,
  assignToJobs: false,
};

export const defaultPinnedDashboardCollection: IPinnedDashboardCollection = {
  id: '',
  dashboardCollection: defaultDashboardCollection,
  users: [],
  teams: [],
  roles: [],
  description: '',
  filters: null,
  entityId: null,
  entityName: null,
};
